import axios from 'axios';
import apiConfig from '../../api.config';

export default async function getInvoiceSFTP(hotelId) {
  const {
    host,
    URIs: { getInvoiceSFTP },
  } = apiConfig;

  const uri = `${host}${getInvoiceSFTP}`.replace(':hotelId', hotelId);

  return await axios.get(uri).then(res => res.data);
}
